(function($){

    $(document).ready(function(){
        // Passing a nodelist
        let elements = document.querySelectorAll(".lazyframe");
        lazyframe(elements);
    });

    $(document).on('facetwp-loaded', function() {
        var qs = FWP.buildQueryString();
        if ( '' === qs ) { // no facets are selected
            $('.facet-reset').hide();
        }
        else {
            $('.facet-reset').show();
        }

        // WP Facets - Hide Search Reset empty
        var searchTerm = FWP.facets['search'];
        if ( searchTerm && searchTerm.length === 0 ) {
            $('.facet-btn-search-reset').hide();
        } else {
            $('.facet-btn-search-reset').show();
        }

        // expand/collapse filters based on screen size
        const tabletWidth = window.matchMedia("(min-width: 768px)");
        $.each(FWP.settings.num_choices, function(key, val) {
            var $facet = $('.facetwp-facet-' + key);
            var $parent = $facet.closest('.facet-wrap');
            var $flyout = $facet.closest('.flyout-row');
            if ($parent.length || $flyout.length) {
                var $which = $parent.length ? $parent : $flyout;
                (0 === val) ? $which.hide() : $which.show();
            
                var bsCollapse = bootstrap.Collapse.getOrCreateInstance($facet.closest('.collapse'),{toggle: false});
                if(tabletWidth.matches) {
                    bsCollapse.show();
                } else {
                    bsCollapse.hide();
                }
            }
        });

    });
})(jQuery);